import { NEW_ROUND, NEW_GAME } from '../reducers/heartsRounds';
export const newRound = () => ({ type: NEW_ROUND });
export const newGame = () => ({ type: NEW_GAME });



// WEBPACK FOOTER //
// ./src/actions/rounds.js